module.exports = __webpack_public_path__ + "img/chip-blue.41b7f95c.png";